export const getPrices = (dispatch: any, dateRange, direction) =>
  dispatch({
    type: "GET_PRICES",
    params: { dateRange, direction },
    direction: direction,
  });

export const getPricesSuccess = (
  prices: any[],
  direction: string,
  page: number,
  pageSize: number,
  total: number
) => ({
  type: "GET_PRICES_SUCCESS",
  prices,
  direction,
  page,
  pageSize,
  total,
});

export const getPricesFailure = (error: Error) => ({
  type: "GET_PRICES_FAILURE",
  error,
});
